import React from 'react';
import {
  ReportsLayoutButtonWrapper,
  ReportsLayoutContainer,
  ReportsLayoutHeader,
  ReportsLayoutTitle,
} from './ReportsLayout.styled';
import { Button, Divider } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ReportButtonConfig, ReportsButtonGroup } from '../ReportsButtonGroup/ReportsButtonGroup';
import useTranslation from 'Hooks/useTranslation';

interface Props {
  title: React.ReactNode;
  buttons: ReportButtonConfig[];
  onExport?: () => void;
}

const ReportsLayout = ({
  title = '',
  children,
  buttons,
  onExport = () => {},
}: React.PropsWithChildren<Props>) => {
  const { t2 } = useTranslation('employees_reports');

  return (
    <ReportsLayoutContainer>
      <ReportsLayoutHeader>
        <ReportsLayoutTitle>{title}</ReportsLayoutTitle>
        <ReportsLayoutButtonWrapper>
          <ReportsButtonGroup buttons={buttons} />
          <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={onExport}>
            {t2('export')}
          </Button>
        </ReportsLayoutButtonWrapper>
      </ReportsLayoutHeader>
      <Divider sx={{ margin: '1rem 0' }} />
      {children}
    </ReportsLayoutContainer>
  );
};

export default ReportsLayout;
